var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"whatsapp-chat",style:({ '--wa-lift': _vm.lift + 'px' }),attrs:{"href":_vm.whatsappUrl,"target":"_blank","rel":"noopener","aria-label":"WhatsApp"}},[_c('img',{attrs:{"src":require("@/assets/whatsapp.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }